// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__jcRFS","header":"ReportDetails_header__wkO-u","title":"ReportDetails_title__3SvEg","left":"ReportDetails_left__2MQuJ"};